export interface ISoccerOverseasState {
  isShow: boolean;
  players?: Array<{
    url: string;
    name: string;
  }>;
}
const initialState: ISoccerOverseasState = {
  isShow: false
};
export default (state: ISoccerOverseasState = initialState) => {
  return state;
};
